export default __webpack_public_path__ + "static/media/money-back@3x.b61c42cb.png";